export const MARKETING_BP_SM = "768px";
export const MARKETING_BP_MD = "1024px";
export const MARKETING_BP_LG = "1515px";

export const COLORS = {
  black: "#222",
  gray: "#f2f2f2",
  brown: "#483d3f",
  white: "#FFF",
  blue: "#4349DC",
  yellow: "#FFEC6D",
  cyan: "#1aefe1",
  pink: "#F7959A",
} as const;

export const HOVER_COLORS = {
  blue: "#3534c4",
  black: "#2c2c2c",
  white: "#d4d5d7",
  transparent: "rgba(150, 150, 150, 0.15)",
  transparentBlue: "rgba(67, 73, 220, 0.15)",
  transparentBlack: "rgba(34, 34, 34, 0.15)",
  yellow: "#f2d66b",
} as const;

export const TYPOGRAPHY = {
  fontSize: {
    xxl: { desktop: "80px", mobile: "60px" },
    xl: { desktop: "56px", mobile: "40px" },
    h1: { desktop: "44px", mobile: "36px" },
    h2: { desktop: "32px", mobile: "28px" },
    h3: { desktop: "28px", mobile: "24px" },
    h4: { desktop: "24px", mobile: "24px" },
    h5: { desktop: "20px", mobile: "16px" },
    eyebrow: { desktop: "20px", mobile: "16px" },
    body: { desktop: "16px", mobile: "16px" },
    small: { desktop: "14px", mobile: "14px" },
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  lineHeight: {
    tight: "120%",
    normal: "140%",
    relaxed: "150%",
  },
  letterSpacing: {
    tight: "-3%",
    normal: "0",
  },
} as const;

export const BUTTON_CONFIG = {
  variants: {
    blue: {
      color: COLORS.white,
      backgroundColor: COLORS.blue,
      hoverColor: COLORS.white,
      hoverBackgroundColor: HOVER_COLORS.blue,
      border: "1px solid transparent",
    },
    white: {
      color: COLORS.black,
      backgroundColor: COLORS.white,
      hoverColor: COLORS.black,
      hoverBackgroundColor: HOVER_COLORS.white,
      border: "1px solid transparent",
    },
    yellow: {
      color: COLORS.black,
      backgroundColor: COLORS.yellow,
      hoverColor: COLORS.black,
      hoverBackgroundColor: HOVER_COLORS.yellow,
      border: "1px solid transparent",
    },
    black: {
      color: COLORS.white,
      backgroundColor: COLORS.black,
      hoverColor: COLORS.white,
      hoverBackgroundColor: HOVER_COLORS.black,
      border: "1px solid transparent",
    },
    outline: {
      color: COLORS.white,
      backgroundColor: "transparent",
      hoverColor: COLORS.white,
      hoverBackgroundColor: HOVER_COLORS.transparent,
      border: `1px solid ${COLORS.white}`,
    },
    outlineBlue: {
      color: COLORS.blue,
      backgroundColor: "transparent",
      hoverColor: COLORS.blue,
      hoverBackgroundColor: HOVER_COLORS.transparentBlue,
      border: `1px solid ${COLORS.blue}`,
    },
    outlineBlack: {
      color: COLORS.black,
      backgroundColor: "transparent",
      hoverColor: HOVER_COLORS.black,
      hoverBackgroundColor: HOVER_COLORS.transparentBlack,
      border: `1px solid ${COLORS.black}`,
    },
  },
  sizes: {
    small: {
      padding: "13.5px 23.6px",
      borderRadius: "38px",
      fontSize: TYPOGRAPHY.fontSize.small.desktop,
    },
    regular: {
      padding: "16px 28px",
      borderRadius: "45px",
      fontSize: TYPOGRAPHY.fontSize.body.desktop,
    },
  },
} as const;

export const TEXT_BUTTON_CONFIG = {
  variants: {
    black: {
      color: COLORS.black,
      hoverColor: HOVER_COLORS.black,
    },
    blue: {
      color: COLORS.blue,
      hoverColor: HOVER_COLORS.blue,
    },
    white: {
      color: COLORS.white,
      hoverColor: HOVER_COLORS.white,
    },
  },
} as const;

export const headingStyles = {
  h1: {
    fontSize: TYPOGRAPHY.fontSize.h1,
    fontWeight: TYPOGRAPHY.fontWeight.medium,
    letterSpacing: TYPOGRAPHY.letterSpacing.tight,
    lineHeight: TYPOGRAPHY.lineHeight.tight,
  },
  h2: {
    fontSize: TYPOGRAPHY.fontSize.h2,
    fontWeight: TYPOGRAPHY.fontWeight.medium,
    lineHeight: TYPOGRAPHY.lineHeight.normal,
  },
  h3: {
    fontSize: TYPOGRAPHY.fontSize.h3,
    fontWeight: TYPOGRAPHY.fontWeight.medium,
    lineHeight: TYPOGRAPHY.lineHeight.tight,
  },
  h4: {
    fontSize: TYPOGRAPHY.fontSize.h4,
    fontWeight: TYPOGRAPHY.fontWeight.medium,
    lineHeight: TYPOGRAPHY.lineHeight.normal,
  },
  h5: {
    fontSize: TYPOGRAPHY.fontSize.h5,
    fontWeight: TYPOGRAPHY.fontWeight.semibold,
    lineHeight: TYPOGRAPHY.lineHeight.normal,
  },
};
